import { render, staticRenderFns } from "./HomeAppointments.vue?vue&type=template&id=484affae"
import script from "./HomeAppointments.vue?vue&type=script&lang=js"
export * from "./HomeAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports